/**
 * Catálogo de vacinas (#530). Não há rota de leitura por id: a edição acha a vacina na lista.
 */
import apiClient from './apiClient';
import type { VaccineType, VaccineTypePayload, VaccineTypeStatus } from '../types/vaccination';

class VaccineTypeService {
  private baseUrl = '/vaccine-types';

  async getAll(status?: VaccineTypeStatus): Promise<VaccineType[]> {
    const response = await apiClient.get<VaccineType[]>(
      `${this.baseUrl}${status ? `?status=${status}` : ''}`
    );
    return response.data ?? [];
  }

  async create(data: VaccineTypePayload): Promise<VaccineType | undefined> {
    const response = await apiClient.post<VaccineType>(this.baseUrl, data);
    return response.data;
  }

  async update(id: string, data: VaccineTypePayload): Promise<VaccineType | undefined> {
    const response = await apiClient.put<VaccineType>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }
}

export const vaccineTypeService = new VaccineTypeService();
export default vaccineTypeService;
